import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

const GoogleOAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing'); // processing, success, error

  useEffect(() => {
    const handleCallback = async () => {
      const state = searchParams.get('state');
      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (error) {
        setStatus('error');
        setTimeout(() => {
          navigate('/digi-calendar?error=google_connection_failed');
        }, 3000);
        return;
      }

      if (!state || !code) {
        setStatus('error');
        setTimeout(() => {
          navigate('/digi-calendar');
        }, 3000);
        return;
      }

      try {
        // Let the backend handle the callback
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/google/callback?state=${state}&code=${code}`,
          {
            method: 'GET',
            redirect: 'follow'
          }
        );

        if (response.ok || response.redirected) {
          setStatus('success');
          setTimeout(() => {
            navigate('/digi-calendar?google_connected=true');
          }, 2000);
        } else {
          throw new Error('Connection failed');
        }
      } catch (err) {
        console.error('OAuth callback error:', err);
        setStatus('error');
        setTimeout(() => {
          navigate('/digi-calendar?error=connection_failed');
        }, 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-12 max-w-md w-full text-center">
        {status === 'processing' && (
          <>
            <Loader2 className="w-16 h-16 text-indigo-600 mx-auto mb-6 animate-spin" />
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Connecting Google Calendar
            </h1>
            <p className="text-gray-600">
              Please wait while we complete the connection...
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Connected Successfully!
            </h1>
            <p className="text-gray-600">
              Redirecting to your calendar...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Connection Failed
            </h1>
            <p className="text-gray-600">
              Unable to connect Google Calendar. Redirecting...
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default GoogleOAuthCallback;
